

import React from 'react';
import { CardBody, Col, Row } from 'reactstrap';
import logoEPoint2 from '../resources/basic_color.png'
import './stylesPages.scss'


function Politicas() {

	return (
		<div>
			<Col xs={7} md={7} lg={7} className="ml-auto mr-auto">
				<CardBody>
					<div className='content'>
						<Row>
							<Col xs={3} className='mr-auto'>
							</Col>
							<Col xs={3} style={{ textAlign: "right" }} className='ml-auto'>
								<img src={logoEPoint2} alt="logo" />
							</Col>
						</Row>
						<hr />
						<h5 className="title-custom-value text-center" >
							POLITICA DE PRIVACIDAD – Onboard Logistics
						</h5>
						<br />
						<br />
					</div>
				</CardBody>
			</Col>
		</div>
	);
}
export default Politicas;
